import styled from 'styled-components';

import {DialogContent} from '../../../../../../../../src/components/common/dialogs/dialogContent';
import {Button} from '../../../../../../../shared/ui/src/components/buttons/button';
import {fontSizes, fontWeights} from '../../../../../../../shared/ui/src/styles/fontStyles';

/*
 * Styles.
 */

export const StyledImportDialogAttachmentsContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
`;

export const StyledImportDialogContent = styled(DialogContent)`
  flex: 1;
  overflow: auto;
  margin: 0 20px;
  padding: 20px 0;
`;

export const StyledImportDialogCancelButton = styled(Button)`
  margin-left: auto;
`;

export const StyledImportDialogImportButton = styled(Button)`
  margin-left: 10px;
`;

export const StyledImportDialogErrorsContainerDiv = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 8px;
`;

export const StyledImportDialogErrorDiv = styled.div`
  color: ${(p) => p.theme.palette.red.shade40};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.medium};

  a {
    color: ${(p) => p.theme.palette.red.shade40};
    font-weight: ${fontWeights.semibold};
    text-decoration: underline;
  }
  &:not(:first-child) {
    margin-top: 8px;
  }
`;
